import { config } from '@/config';
import { cn } from '@/lib/utils';
import React from 'react';

type HatchetLogoProps = React.SVGAttributes<SVGSVGElement> & {
  title?: string;
  colorVariant?: 'brand' | 'inherit';
  variant?: 'lockup' | 'mark' | 'wordmark';
};

const SOURCE_WIDTH = 1825.27;
const SOURCE_HEIGHT = 407.13;
const MARK_VIEW_BOX = '0 0 180 180';
const WORDMARK_VIEW_BOX = '410 95 1430 140';
const LOCKUP_VIEW_BOX = `0 0 ${SOURCE_WIDTH} ${SOURCE_HEIGHT}`;

/**
 * Official High Stakes artwork. The legacy export name keeps the upstream
 * integration surface small.
 */
export function HatchetLogo({
  title = 'High Stakes',
  colorVariant = 'brand',
  variant = 'lockup',
  className,
  ...props
}: HatchetLogoProps) {
  const assetBasePath = config.BASE_PATH === '/' ? '' : config.BASE_PATH;
  const iconHref = `${assetBasePath}/highstakes-icon.png`;
  const logoHref = `${assetBasePath}/highstakes-logo.svg`;
  const viewBox =
    variant === 'mark'
      ? MARK_VIEW_BOX
      : variant === 'wordmark'
        ? WORDMARK_VIEW_BOX
        : LOCKUP_VIEW_BOX;

  return (
    <svg
      viewBox={viewBox}
      xmlns="http://www.w3.org/2000/svg"
      role="img"
      aria-label={title}
      className={cn(colorVariant === 'brand' && 'text-foreground', className)}
      {...props}
    >
      <title>{title}</title>
      {variant === 'mark' ? (
        <image href={iconHref} width="180" height="180" />
      ) : (
        <image href={logoHref} width={SOURCE_WIDTH} height={SOURCE_HEIGHT} />
      )}
    </svg>
  );
}
